import React from 'react';
import { NavLink } from 'react-router-dom';

import { css } from '@emotion/css';
import { Box } from '@opendoor/bricks/core';
import { IIconNavBarItem } from '@opendoor/bricks/deprecated/UNSAFE_layout/IconNavBar';
import { colors, radii } from '@opendoor/bricks/theme/eero';

interface ITabProps {
  item: IIconNavBarItem;
  content: JSX.Element;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const Tab: React.FC<ITabProps> = ({ item, content, onClick }) => {
  let isActive: NavLink['props']['isActive'];
  if (typeof item.isActive === 'boolean') {
    isActive = () => {
      return item.isActive as boolean;
    };
  }

  return (
    <NavLink
      to={item.link}
      style={{
        color: 'inherit',
      }}
      onClick={onClick}
      activeClassName={css`
        display: block;
        background-color: rgba(61, 133, 225, 0.08);
        border-radius: ${radii.roundedSquare};
        color: ${colors.brand50} !important;
        cursor: default;
        font-weight: 500;
        path {
          stroke: ${colors.brand50} !important;
        }
        rect {
          stroke: ${colors.brand50} !important;
        }
      `}
      isActive={isActive}
    >
      <Box mb={4} textDecoration="none">
        {content}
      </Box>
    </NavLink>
  );
};
